/**
 * Script de consola para probar el sistema de categorías habilitadas
 */

// Exportar para que TypeScript considere esto un módulo
export {};

// Función para probar categorías habilitadas
(window as any).testEnabledCategories = async function() {
  console.log('🧪 Probando sistema de categorías habilitadas...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    // Crear algunas categorías de prueba
    console.log('📂 Creando categorías de prueba...');
    
    const testCategories = [
      { name: 'Campera', fields: { material: { type: 'text', required: true } } },
      { name: 'Buzo', fields: { material: { type: 'text', required: true } } },
      { name: 'Remera', fields: { material: { type: 'text', required: true } } }
    ];
    
    const createdCategories = [];
    
    for (const categoryData of testCategories) {
      try {
        const categoryName = await optimizedService.createCategory(categoryData);
        createdCategories.push({ name: categoryData.name, id: categoryName });
        console.log(`✅ Categoría "${categoryData.name}" creada`);
      } catch (error) {
        console.log(`⚠️ Categoría "${categoryData.name}" ya existe o error:`, error instanceof Error ? error.message : error);
      }
    }
    
    // Verificar categorías creadas
    console.log('\n📋 Verificando categorías creadas...');
    const allCategories = await optimizedService.getCategories();
    console.log(`Total de categorías: ${allCategories.length}`);
    
    allCategories.forEach(category => {
      console.log(`  - ${category.name} (${category.id}) - Habilitada: ${category.enabled !== false}`);
    });
    
    // Probar habilitar/deshabilitar
    if (createdCategories.length > 0) {
      const firstCategory = createdCategories[0];
      console.log(`\n🔄 Probando toggle de categoría "${firstCategory.name}"...`);
      
      // Deshabilitar
      await optimizedService.updateCategory(firstCategory.id, { enabled: false });
      console.log(`❌ Categoría "${firstCategory.name}" deshabilitada`);
      
      // Verificar estado
      const updatedCategories = await optimizedService.getCategories();
      const updatedCategory = updatedCategories.find(cat => cat.id === firstCategory.id);
      console.log(`Estado actual: ${updatedCategory?.enabled !== false ? 'Habilitada' : 'Deshabilitada'}`);
      
      // Habilitar nuevamente
      await optimizedService.updateCategory(firstCategory.id, { enabled: true });
      console.log(`✅ Categoría "${firstCategory.name}" habilitada nuevamente`);
    }
    
    console.log('\n🎉 Prueba de categorías habilitadas completada');
    return {
      created: createdCategories.length,
      total: allCategories.length,
      enabled: allCategories.filter(cat => cat.enabled !== false).length
    };
    
  } catch (error) {
    console.error('❌ Error en prueba de categorías habilitadas:', error);
    throw error;
  }
};

// Función para verificar solo categorías habilitadas
(window as any).getEnabledCategories = async function() {
  console.log('🔍 Obteniendo solo categorías habilitadas...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const allCategories = await optimizedService.getCategories();
    const enabledCategories = allCategories.filter(cat => cat.enabled !== false);
    
    console.log(`📊 Total: ${allCategories.length}, Habilitadas: ${enabledCategories.length}`);
    
    enabledCategories.forEach(category => {
      console.log(`  ✅ ${category.name} (${category.id})`);
    });
    
    return enabledCategories;
    
  } catch (error) {
    console.error('❌ Error obteniendo categorías habilitadas:', error);
    throw error;
  }
};

// Función para habilitar todas las categorías
(window as any).enableAllCategories = async function() {
  console.log('🔓 Habilitando todas las categorías...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const allCategories = await optimizedService.getCategories();
    let enabledCount = 0;
    
    for (const category of allCategories) {
      if (category.enabled === false) {
        await optimizedService.updateCategory(category.id, { enabled: true });
        console.log(`✅ Categoría "${category.name}" habilitada`);
        enabledCount++;
      }
    }
    
    console.log(`🎉 ${enabledCount} categorías habilitadas`);
    return enabledCount;
    
  } catch (error) {
    console.error('❌ Error habilitando categorías:', error);
    throw error;
  }
};

// Función para deshabilitar todas las categorías
(window as any).disableAllCategories = async function() {
  console.log('🔒 Deshabilitando todas las categorías...');
  
  try {
    const { default: optimizedService } = await import('../services/optimizedInventoryService');
    
    const allCategories = await optimizedService.getCategories();
    let disabledCount = 0;
    
    for (const category of allCategories) {
      if (category.enabled !== false) {
        await optimizedService.updateCategory(category.id, { enabled: false });
        console.log(`❌ Categoría "${category.name}" deshabilitada`);
        disabledCount++;
      }
    }
    
    console.log(`🎉 ${disabledCount} categorías deshabilitadas`);
    return disabledCount;
    
  } catch (error) {
    console.error('❌ Error deshabilitando categorías:', error);
    throw error;
  }
};

console.log('🧪 Scripts de categorías habilitadas cargados:');
console.log('- window.testEnabledCategories() - Probar sistema completo');
console.log('- window.getEnabledCategories() - Ver solo categorías habilitadas');
console.log('- window.enableAllCategories() - Habilitar todas las categorías');
console.log('- window.disableAllCategories() - Deshabilitar todas las categorías');
